<template>
  <v-app class="view">
    <v-dialog
        v-model="EditObjectDialog"
        max-width="700"
        overlay-opacity="0.8"
        persistent
    >
      <form v-if="selectedObject" @submit.prevent="onSubmitObject">
        <v-card class="pa-8">
          <v-tabs v-model="tab">
            <v-tab>Setting</v-tab>
            <v-tab>Properties</v-tab>
            <v-tab>Route</v-tab>
            <v-tab>Remark</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-container class="tab-item">
                <v-row>
                  <v-col md="4">
                    <v-text-field

                        v-model="selectedObject.plate"
                        class="dialog-input"
                        hide-details
                        label="ทะเบียน"
                        outlined
                        placeholder=""
                        required
                    >
                    </v-text-field>

                  </v-col>
                  <v-col>
                    <v-text-field

                        v-model="selectedObject.name"
                        class="dialog-input"
                        hide-details
                        label="ชื่อรถ"
                        outlined
                        placeholder=""
                        required
                    >
                    </v-text-field>

                  </v-col>

                </v-row>

                <v-row>
                  <v-col md="2">
                    <v-text-field

                        v-model="selectedObject.erp_code"
                        class="dialog-input"
                        hide-details
                        label="รหัสรถ"
                        outlined
                        placeholder=""
                        required
                    >
                    </v-text-field>

                  </v-col>


                  <v-col md="4">

                    <v-select
                        v-model="selectedObject.type"
                        :items="[
                      {'value':'VAN','text':'รถตู้'},
                      {'value':'ICE-CREAM','text':'รถไอติม'},
                      {'value':'SINGLE-HEAD','text':'รถกระบะหัวเดี่ยว'},
                      {'value':'CAB','text':'รถกระบะมี CAB'},
                      {'value':'SMALL-4WL','text':'รถ 4 ล้อเล็ก'},
                      {'value':'MEDIUM-4WL','text':'รถ 4 ล้อกลาง'},
                      {'value':'MEDIUM-6WL','text':'รถ 6 ล้อ'},
                      {'value':'SERVICE-CAB','text':'รถช่าง'},
                      {'value':'CAR','text':'รถเก๋ง'},
                      {'value':'TRAY-4WL','text':'รถ 4 ล้อ คอก'},
                      {'value':'LARGE-10WL','text':'รถ 10 ล้อ'},
                    ]"
                        hide-details
                        label="ชนิด"
                        outlined
                    ></v-select>
                  </v-col>
                  <v-col md="3">
                    <v-text-field

                        v-model="selectedObject.driver_amount"
                        class="dialog-input"
                        hide-details
                        label="จำนวนคนขับ"
                        outlined
                        placeholder=""
                        required
                        suffix="คน"
                        type="number"
                    >
                    </v-text-field>

                  </v-col>
                  <v-col>
                    <v-text-field

                        v-model="selectedObject.wage_per_day"
                        class="dialog-input"
                        hide-details
                        label="เบี้ยเลี้ยง"
                        outlined
                        placeholder="300"
                        prefix="วันละ"
                        required

                        suffix="บาท"
                        type="number"
                    >
                    </v-text-field>

                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-container class="tab-item">
                <v-row>
                  <v-col>
                    <v-text-field

                        v-model="selectedObject.truck_weight"
                        class="dialog-input"
                        hide-details
                        label="น้ำหนักรถ"
                        outlined
                        placeholder=""
                        required
                        suffix="kg"
                        type="number"
                    >
                    </v-text-field>

                  </v-col>
                  <v-col>
                    <v-text-field

                        v-model="selectedObject.max_weight"
                        class="dialog-input"
                        hide-details
                        label="น้ำหนักบรรทุก"
                        outlined
                        placeholder=""
                        required
                        suffix="kg"
                        type="number"
                    >
                    </v-text-field>

                  </v-col>


                  <v-col>
                    <v-text-field

                        v-model="selectedObject.max_cbm"
                        class="dialog-input"
                        hide-details
                        label="ปริมาตรบรรทุก"
                        outlined
                        placeholder=""
                        required
                        step="0.01"
                        suffix="cbm"
                        type="number"
                    >
                    </v-text-field>

                  </v-col>
                  <v-col>
                    <v-text-field

                        v-model="selectedObject.speed_kmh"
                        class="dialog-input"
                        hide-details
                        label="ความเร็ว"
                        outlined
                        placeholder=""
                        required
                        suffix="kmh"
                        type="number"
                    >
                    </v-text-field>

                  </v-col>

                </v-row>

                <v-row>
                  <v-col cols="3">
                    <v-text-field

                        v-model="selectedObject.consumption_per_km"
                        class="dialog-input"
                        hide-details
                        label="ค่าน้ำมัน"
                        outlined
                        placeholder="2"
                        prefix="กม.ละ"
                        required
                        step=".01"
                        suffix="บาท"
                        type="number"
                    >
                    </v-text-field>

                  </v-col>
                  <v-col>

                    <v-text-field

                        v-model="new Date(selectedObject.available_datetime).toLocaleDateString('th-TH')"
                        class="dialog-input"
                        hide-details
                        label="เริ่มใช้งานได้"
                        outlined
                        placeholder=""
                        readonly
                        @click="$root.$emit('openDatePicker',{date:new Date(selectedObject.available_datetime).toISOString().substr(0,10),onApply:date=>selectedObject.available_datetime=date})"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-select
                        v-model="selectedObject.mt_enabled"
                        :items="[
                      {'value':TruckConst.ENABLE_NONE,'text':'ไม่ส่ง'},
                      {'value':TruckConst.ENABLE_IF_ABLE,'text':'เมื่อรถว่าง'},
                      {'value':TruckConst.ENABLE_ALL,'text':'ส่งเสมอ'},
                    ]"
                        hide-details
                        label="MT"
                        outlined
                    ></v-select>


                  </v-col>
                  <v-col cols="3">
                    <v-select
                        v-model="selectedObject.pj_enabled"
                        :items="[
                      {'value':TruckConst.ENABLE_NONE,'text':'ไม่ส่ง'},
                      {'value':TruckConst.ENABLE_IF_ABLE,'text':'เมื่อรถว่าง'},
                      {'value':TruckConst.ENABLE_ALL,'text':'ส่งเสมอ'},
                    ]"
                        hide-details
                        label="PJ"
                        outlined
                    ></v-select>

                  </v-col>

                </v-row>
<!--                <v-row>-->
<!--                  <v-col cols="4">-->
<!--                    <v-select-->
<!--                        v-model="selectedObject.province_enabled"-->
<!--                        :items="[-->
<!--                      {'value':TruckConst.PROVINCE_ALL,'text':'ส่งทุกที่'},-->
<!--                      {'value':TruckConst.PROVINCE_NEAR,'text':'จังหวัดใกล้เคียง'},-->
<!--                      {'value':TruckConst.PROVINCE_MIDDLE,'text':'จังหวัดระยะกลาง'},-->
<!--                      {'value':TruckConst.PROVINCE_FAR,'text':'จังหวัดห่างไกล'},-->
<!--                    ]"-->
<!--                        hide-details-->
<!--                        label="ส่งจังหวัด"-->
<!--                        outlined-->
<!--                    ></v-select>-->

<!--                  </v-col>-->

<!--                </v-row>-->


              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-container class="tab-item">
                <v-row>
                  <v-col>
                    <div style="max-height: calc(90vh - 250px);overflow: scroll">
                    <v-treeview
                        v-model="selectedObject.transport_routes"
                        :items="transportRoute"
                        selectable
                    >
                    </v-treeview>
                    </div>
                  </v-col>
                </v-row>
              </v-container>

            </v-tab-item>
            <v-tab-item>
              <v-container class="tab-item">


                <v-row>
                  <v-col>
                    <v-textarea

                        v-model="selectedObject.remark"
                        class="dialog-input"
                        hide-details
                        label="หมายเหตุ"
                        outlined
                        placeholder=""
                        rows="3"
                    >
                    </v-textarea>

                  </v-col>
                </v-row>


              </v-container>
            </v-tab-item>
          </v-tabs-items>


          <v-btn class="close-button float-left" color="gray" fab tile @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn class="float-left mt-4 ml-12" color="" plain small text @click="deletingObject()">
            <v-icon x-small>mdi-delete</v-icon>
            ลบรถ
          </v-btn>
          <v-btn :loading="objectLoading" class="close-button float-right" color="primary" fab tile type="submit">
            <v-icon>mdi-check-bold</v-icon>
          </v-btn>
          <v-checkbox
              v-model="selectedObject.enabled"
              class="dialog-input  float-right mr-8"
              label="ใช้งาน"
              outlined
          >
          </v-checkbox>
          <div style="clear: both"></div>
        </v-card>
      </form>
    </v-dialog>

    <Menu :drawerWidth="drawer_width"></Menu>
    <v-content>
      <v-container
          :style="{
                        paddingLeft:(12+drawer_width)+'px',
                     }"
          child-flex
          class="container"

          fluid>
        <v-card>
          <v-card-title>
            จัดการรถ
            <v-spacer></v-spacer>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                hide-details
                label="ค้นหา"
                single-line
            ></v-text-field>
          </v-card-title>
          <v-data-table
              v-if="objects && Array.isArray(objects)"
              :headers="[
                        { text: 'ทะเบียน', value: 'plate' , width: '120px', fixed: true},
                        { text: 'ชนิด', value: 'type' },
                        { text: 'ชื่อ', value: 'name' },
                        { text: 'คนขับ', value: 'driver_name' },
                        { text: 'สถานะ', value: 'status' , width: '120px', fixed: true },
                        { text: 'แก้ไข', value: 'edit', width: '80px', fixed: true },
                      ]"
              :items="objects"
              :loading="objectsLoading"

              :search="search"
              class="elevation-1 mb-12 tr-clickable"
              @click:row="editObject"
          >
            <template v-slot:item.edit="{ item }">
              <v-btn class="primary" outlined small @click.stop="editObject(item)">แก้ไข</v-btn>
            </template>
            <template v-slot:item.enabled="{ item }">
              {{ item.enabled ? 'เปิดใช้งาน' : 'ปิด' }}
            </template>
            <template v-slot:item.type="{ item }">
              {{ TruckConst.map(item.type) }}
            </template>
            <template v-slot:item.name="{ item }">
              {{item.name }}

              <v-btn v-if="item.transport_routes === null || item.transport_routes.length===0"
                     class="ml-1 red pa-1 caption" style="color: white" x-small>

                ยังไม่ได้ระบุเส้นทาง
              </v-btn>


            </template>
          </v-data-table>
          <v-btn absolute

                 bottom
                 class="close-button float-left"
                 color="primary"
                 fab
                 left @click="newObject">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card>


      </v-container>
    </v-content>


  </v-app>
</template>
<style lang="scss" scoped>


.view {
  font-size: 18px;
}

.nav {
  z-index: 1;
}

.container {
  position: relative;
  margin-top: 0;
}

.pad-filter {
  padding: 16px 0 0 24px;
}

.search .v-input__control {
  /*height: 60px;*/
}

.theme--light .list-header-row {
  background: #FFFFFF;
}

.theme--dark .list-header-row {
  background: #000000;
}

.theme--light .primary {
  color: #FFFFFF !important;
}

.tab-item {
  min-height: 360px;
}

</style>
<script lang="ts">

import Menu from '@/components/Logistic/Menu.vue'
import {SimpleResponse} from '@/models/Model'
import {DataArray} from '@/models/Response'
import {TransportRoute} from '@/models/TransportRoute'
import {Truck, TruckConst} from '@/models/Truck'
import {Component, Vue} from 'vue-property-decorator'
import LoadingDummy from '../components/LoadingDummy.vue'
import Helper from '../services/Helper.js'

@Component({
  components: {LoadingDummy, Menu},
})
export default class ViewAdminTruck extends Vue {
  tab = null
  search = ''

  drawer_ratio = 0.15
  drawer_width = 200

  show_password = false

  objects: Truck[] = []

  objectLoading = false
  objectsLoading = false
  EditObjectDialog = false
  selectedObject: Truck | null = null

  TruckConst = TruckConst


  transportRoute: TransportRoute[] = []

  async editObject(object: Truck) {
    this.objectLoading = true

    this.EditObjectDialog = true

    if (object.id) {
      this.selectedObject = new Truck()
      this.selectedObject = await (new Truck()).load<Truck>(object.id)
    }

    this.objectLoading = false

  }

  newObject() {
    this.selectedObject = new Truck()
    this.selectedObject.enabled = true
    this.EditObjectDialog = true

  }

  cancel() {

    this.EditObjectDialog = false
  }

  async onSubmitObject() {
    this.objectLoading = true
    const isNew = this.selectedObject?.id === null

    this.selectedObject = Object.setPrototypeOf(this.selectedObject, Truck.prototype)

    if (this.selectedObject) {
      try{
        let object = await this.selectedObject.save<Truck>()
        this.$root.$emit('onSuccess', {message: 'บันทึกสำเร็จ'})



        if (isNew) {
          this.objects.push(object)
        } else {
          for (let i in this.objects) {
            if (this.objects[i].id == object.id) {
              this.objects[i] = object
            }
          }
        }
      }catch (e){
        this.$root.$emit('onError', {error: e})
      }
      this.objectLoading = false
    }
    this.selectedObject = null
    this.EditObjectDialog = false
  }

  async deletingObject() {
    this.$confirm('ยืนยันลบข้อมูล?').then(res => {
      if (res) {
        this.deleteObject()
      }
    })

  }

  async deleteObject() {
    try {
      if (this.selectedObject == null) return
      this.objectLoading = true

      this.selectedObject = Object.setPrototypeOf(this.selectedObject, Truck.prototype)

      const response: SimpleResponse = await this.selectedObject?.delete()

      this.objects = this.objects.filter(object => object.id != this.selectedObject?.id)

      this.selectedObject = null
      this.EditObjectDialog = false

      this.$root.$emit('onSuccess', {message: response.toString()})
    } catch (e) {
      console.log(e)
      this.$root.$emit('onError', {error: e})
    }
    this.objectLoading = false
  }

  async mounted() {
    this.drawer_width = Math.max(80, Math.round(window.innerWidth * this.drawer_ratio))
    console.log('window.innerWidth', window.innerWidth)


    this.refreshTruck().then(() => {
    })
    this.refreshTransportRoute().then(() => {
    })


  }

  async refreshTruck() {
    const url = Helper.setting.truck.getListAPI

    try {
      this.objectsLoading = true
      this.objects = await Helper.get(url).then<{ data: DataArray }>(({data}) => data.data)
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
    this.objectsLoading = false
  }

  async refreshTransportRoute() {
    const url = Helper.setting.transportRoute.getListAPI

    try {
      this.transportRoute = await Helper.get(url).then<{ data: DataArray }>(({data}) => data.data)
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
    this.objectsLoading = false
  }

}
</script>
